import type { DataSource, ImportedRows } from '../../dataSource/dataSource'
import type { ProjectLayout } from './plan'

/**
 * **Wie die schon übernommenen Projekte in HappyTask stehen** (#317) — vor dem Planen gelesen, damit
 * ein zweiter Import Neues in die Lücken legt statt hinter den letzten Abschnitt. Gelöschte Projekte
 * bekommen ohnehin nichts.
 */
export async function loadProjectLayouts(
  source: Pick<DataSource, 'getTasksByProject' | 'getSectionsByProject'>,
  imported: ImportedRows,
): Promise<Map<string, ProjectLayout>> {
  const ids = [...imported.projects.values()].filter(row => !row.deleted).map(row => row.id)
  const layouts = await Promise.all(ids.map(async id => {
    const [tasks, sections] = await Promise.all([source.getTasksByProject(id), source.getSectionsByProject(id)])
    return [id, { tasks, sections }] as const
  }))
  return new Map(layouts)
}
